// Webpack Imports
import * as bootstrap from 'bootstrap';

var animationSpeed = 200,
  mCustomScrollbarActive = null,
  heightHeaderMobile = 78,
  nakiedyUrl = 'https://sensusmed.nakiedy.pl',
  isMobileBrowser = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    }, BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    }, iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }, Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    }, Windows: function () {
      return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    }, any: function () {
      return (isMobileBrowser.Android() || isMobileBrowser.BlackBerry() || isMobileBrowser.iOS() || isMobileBrowser.Opera() || isMobileBrowser.Windows());
    }
  }
  ;

(function () {
  'use strict';

})();

$(window).resize(function () {
  mCustomScrollbarInit();
});

$(document).ready(function () {

  var iPhoneVersion = getiPhoneModel();
  if (iPhoneVersion.indexOf('7') >= 0) {
    $("body").addClass("is-iphone-7");
  }
  mCustomScrollbarInit();
  mainPageSliderInit();
  opinionsSliderInit();
  desktopMenuStuff();
  mobileMenuToggler();
  mobileMenuExpander();
  niceTabsInit();
  loadMoreButtons();
  offerSubMenu();
  accordionInit();
  lightbox();
  cookieInfo();
  nakiedyStuff();
});

var menuCloseTimeout = null;
var submenuCloseTimeout = null;
function desktopMenuStuff() {
  $('nav li.offer-submenu').on({
    'mouseenter': function () {
      $('nav li.offer-submenu').addClass('submenu-opened');
      if (menuCloseTimeout) {
        clearTimeout(menuCloseTimeout);
      }
    },
    'mouseleave': function () {
      menuCloseTimeout = setTimeout(function () {
        $('nav li.offer-submenu').removeClass('submenu-opened');
      }, 500);
    }
  });

  $('nav li.offer-submenu li').on({
    'mouseenter': function () {
      $('nav li.safe-escape-time').removeClass('safe-escape-time');
    },
    'mouseleave': function () {

    }
  });

  $('nav li.has-safe-submenu li').on({
    'mouseenter': function () {
      $('nav li.safe-escape-time').removeClass('safe-escape-time');
      $(this).parents('li.has-safe-submenu').addClass('safe-escape-time');
      if (submenuCloseTimeout) {
        clearTimeout(submenuCloseTimeout);
      }
    },
    'mouseleave': function () {
      submenuCloseTimeout = setTimeout(function () {
        $('nav li.safe-escape-time').removeClass('safe-escape-time');
      }, 500);
    }
  });

  $('header nav.classic-menu ul > li.offer-submenu > ul ul').on({
    'mouseenter': function() {
      $(this).parents('.shadowable').addClass('shadow-menu');
    },
    'mouseleave': function() {
      $('header nav.classic-menu .shadowable').removeClass('shadow-menu');
    }
  });
}

function mCustomScrollbarInit() {
  if (isMobile() && mCustomScrollbarActive) {
    mCustomScrollbarActive = false;
    $(".mcs-content").mCustomScrollbar("disable");
  } else if(!isMobile() && !mCustomScrollbarActive){
    mCustomScrollbarActive = true;
    $(".mcs-content").css('max-height', '500px');
    $(".mcs-content").mCustomScrollbar({
      theme: "dark"
    });
  }
}

function lightbox() {
  $('.blocks-gallery-grid a, .lightbox-gallery a').simpleLightbox({
    animationSpeed: 100,
    animationSlide: false,
    fadeSpeed: 100
  });
}

function mainPageSliderInit() {
  $('.main-page-slider').slick({
    dots: $('.main-page-slider .slide').length > 1,
    arrows: false,
    fade: true
  });
}

function isMobile() {
  return $('main#main').outerWidth() < 1200;
}

function mobileMenuToggler() {
  $('#hamburger').on('click', function () {
    $('body').toggleClass('menu-opened');
  });
}

function mobileMenuExpander() {
  $('nav .expand').on('click', function () {
    $(this)
      .parents('li').toggleClass('show-submenu');
    $(this).parents('.expand-holder')
      .toggleClass('arrow-rotate')
      .next().slideToggle(animationSpeed);
  });
}

function niceTabsInit() {

  niceTabsNavigation();

  $('.nice-tabs__body-head, .nice-tabs__head').on('click', function () {
    var clicked = $(this);
    toggleActiveNiceTab(clicked);
  });

  function toggleActiveNiceTab(clicked) {
    var tabIndex = clicked.data('index');

    if (clicked.hasClass('active') || clicked.hasClass('first-active')) {

      if (!isMobile())
        return;

      clicked.removeClass('active');
      $('.nice-tabs__body-wrapper-' + tabIndex).removeClass('active ');
      $('.nice-tabs__head-' + tabIndex).removeClass('active');
      if (isMobile())
        $('.nice-tabs__body-' + tabIndex).slideUp(animationSpeed);
      else
        $('.nice-tabs__body-' + tabIndex).hide();
    } else {

      $('.nice-tabs__head').removeClass('active first-active')
      $('.nice-tabs__body-wrapper').removeClass('active first-active');
      $('.nice-tabs__body-head').removeClass('active first-active')

      if (isMobile())
        $('.nice-tabs__body').slideUp(animationSpeed)
      else
        $('.nice-tabs__body').hide();

      clicked.addClass('active');
      $('.nice-tabs__head-' + tabIndex).addClass('active');
      $('.nice-tabs__body-wrapper-' + tabIndex).addClass('active');

      if (isMobile()) {
        $('.nice-tabs__body-' + tabIndex).slideDown(animationSpeed, function () {
          scrollToId('nice-tabs__body-wrapper-' + tabIndex, -1 * heightHeaderMobile);
        });
      } else {
        $('.nice-tabs__body-' + tabIndex).fadeIn(animationSpeed);
      }
    }
  }

  function niceTabsNavigation() {
    if (!window.location.hash || !$('.nice-tabs').length) {
      return;
    }
    var hash = window.location.hash.replace('#', '');
    hash = parseInt(hash.replace('tab', '')) - 1;
    var clicked = $('.nice-tabs__body-head-' + hash);
    if(!clicked.length) {
      return;
    }

    toggleActiveNiceTab(clicked);
    scrollToId('training-tabs', -100);
  }
}

function loadMoreButtons() {
  $('.js-load-more-team').on('click', function () {
    $('#team-grid .worker').removeClass('worker--hidden-mobile');
    $(this).addClass('btn-hidden');
  });
}

function opinionsSliderInit() {
  $('#opinions-slider').slick({
    adaptiveHeight: true,
    arrows: false,
    centerMode: true,
    centerPadding: '500px',
    dots: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 450,
        settings: {
          centerPadding: '50px',
        }
      },
      {
        breakpoint: 650,
        settings: {
          centerPadding: '80px',
        }
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: '120px',
        }
      },
      {
        breakpoint: 1200,
        settings: {
          centerPadding: '150px',
        }
      },
      {
        breakpoint: 1400,
        settings: {
          centerPadding: '200px',
        }
      },
      {
        breakpoint: 1600,
        settings: {
          centerPadding: '300px',
        }
      },
      {
        breakpoint: 1800,
        settings: {
          centerPadding: '375px',
        }
      }

    ]
  })
}

var submenuTimeout = null;

function offerSubMenu() {
  $('header li.offer-submenu, #desktop-offer-content').on('mouseenter, mousemove', function () {
    toggleOfferSubmenu(true);
  });

  $('#desktop-offer-content, header li.offer-submenu').on('mouseleave', function (e) {
    submenuTimeout = setTimeout(function () {
      toggleOfferSubmenu(false);
    }, 100);
  });

  $('#desktop-offer-content').on('mousemove', function () {
    clearTimeout(submenuTimeout);
    toggleOfferSubmenu(true);
  })

  function toggleOfferSubmenu(show) {
    if (show) {
      $('#desktop-offer, header li.offer-submenu > a').addClass('show');
    } else {
      $('#desktop-offer, header li.offer-submenu > a').removeClass('show');
    }
  }

  $('.vertical-tabs__head, .vertical-tabs__mobile-title').on('click', function (event) {
    if (event.target.tagName.toLowerCase() == 'a') {
      return;
    }

    var container = $(this).parents('.vertical-tabs-container'),
      tabIndex = $(this).data('index'),
      hasMobile = $(this).parents('.vertical-tabs').hasClass('has-mobile')
      ;

    if (hasMobile) {
      container.find('.vertical-tabs__mobile-title.active').removeClass('active');
      container.find('.vertical-tabs__head.active').removeClass('active');
      container.find('.vertical-tabs__body.active').hide(animationSpeed);
    } else {
      container.find('.active').removeClass('active');
      container.find('.vertical-tabs__body').hide();
    }


    $(this).addClass('active');

    if (hasMobile) {
      container.find('.vertical-tabs__body-' + tabIndex)
        .show()
        .addClass('active')
        ;

      setTimeout(function () {
        scrollToId('vertical-tabs__body-mobile-anchor-' + tabIndex, -3 * heightHeaderMobile);
      }, animationSpeed + 100);
    } else {
      container.find('.vertical-tabs__body-' + tabIndex).fadeIn(animationSpeed, function () {
        container.find('.vertical-tabs__body-' + tabIndex).addClass('active');
      });
    }


  });
}

function scrollToId(targetId, shift) {
  if (!$('#' + targetId).length)
    return;

  $("html, body").animate({
    scrollTop: $('#' + targetId).offset().top + (shift ? shift : 0)
  }, animationSpeed);
}

function accordionInit() {
  $('.accordion').each(function () {

  });

  $('.accordion__head').on('click', function () {
    var clicked = $(this),
      accoIndex = clicked.data('index'),
      container = clicked.parents('.accordion');

    if (clicked.hasClass('active')) {
      clicked.removeClass('active');
      container.find('.accordion__body-' + accoIndex).slideUp();
    } else {
      clicked.addClass('active');
      container.find('.accordion__body-' + accoIndex).slideDown();
    }

  });
}

function cookieInfo() {

  if (Cookies.get('cookie-popup') !== 'set')
    toggleCookiePopup(true);

  $('.js-accept-cookies').on('click', function () {
    toggleCookiePopup(false);
    Cookies.set('cookie-popup', 'set',)
  });

  function toggleCookiePopup(show) {
    if (show === true)
      setTimeout(function () {
        $('.cookie-overlay').fadeIn();
      }, isMobile() ? 0 : 1000);
    else
      $('.cookie-overlay').fadeOut(isMobile() ? 0 : 1000);
  }
}

function nakiedyStuff() {

  $('a[href="#rezerwacja-link"]').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (isMobileBrowser.any()) {
      window.open(nakiedyUrl);
    } else {
      toggleReservationModal(true);
    }
  });


  $("#reservation-overlay").on('click', function (e) {
    if (e.target === this)
      toggleReservationModal(false);
  });

  $('#close-overlay').on('click', function () {
    toggleReservationModal(false);
  });
}

function toggleReservationModal(show) {

  var overlay = jQuery('#reservation-overlay'),
    body = jQuery('body')
    ;

  if (show === true) {
    overlay
      .css("display", "flex")
      .hide()
      .fadeIn(function () {
        body.addClass('modal-open');
      });
    showIframe();
  } else if (show === false) {
    overlay.fadeOut(function () {
      body.removeClass('modal-open');
    });
  }
}

function showIframe() {
  var modal = $('#modal-body');

  if (modal.hasClass('loaded'))
    return;

  modal.addClass('loaded');
  modal.html('<iframe src="' + nakiedyUrl + '" frameborder="0" scrolling="yes">');

  var modalHeight = $('#reservation-modal').height(),
    titleHeight = $('#modal-title').outerHeight()
    ;

  modal.find('iframe').css('height', modalHeight - titleHeight - 40 + 'px');
}

function getiPhoneModel() {
  // Create a canvas element which can be used to retrieve information about the GPU.
  var canvas = document.createElement("canvas");
  if (canvas) {
    var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    if (context) {
      var info = context.getExtension("WEBGL_debug_renderer_info");
      if (info) {
        var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
      }
    }
  }

  // iPhone X
  if ((window.screen.height / window.screen.width == 812 / 375) && (window.devicePixelRatio == 3)) {
    return "iPhone X";
    // iPhone 6+/6s+/7+ and 8+
  } else if ((window.screen.height / window.screen.width == 736 / 414) && (window.devicePixelRatio == 3)) {
    switch (renderer) {
      default:
        return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus";
      case "Apple A8 GPU":
        return "iPhone 6 Plus";
      case "Apple A9 GPU":
        return "iPhone 6s Plus";
      case "Apple A10 GPU":
        return "iPhone 7 Plus";
      case "Apple A11 GPU":
        return "iPhone 8 Plus";
    }
    // iPhone 6+/6s+/7+ and 8+ in zoom mode
  } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 3)) {
    switch (renderer) {
      default:
        return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus (display zoom)";
      case "Apple A8 GPU":
        return "iPhone 6 Plus (display zoom)";
      case "Apple A9 GPU":
        return "iPhone 6s Plus (display zoom)";
      case "Apple A10 GPU":
        return "iPhone 7 Plus (display zoom)";
      case "Apple A11 GPU":
        return "iPhone 8 Plus (display zoom)";
    }
    // iPhone 6/6s/7 and 8
  } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 2)) {
    switch (renderer) {
      default:
        return "iPhone 6, 6s, 7 or 8";
      case "Apple A8 GPU":
        return "iPhone 6";
      case "Apple A9 GPU":
        return "iPhone 6s";
      case "Apple A10 GPU":
        return "iPhone 7";
      case "Apple A11 GPU":
        return "iPhone 8";
    }
    // iPhone 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
  } else if ((window.screen.height / window.screen.width == 1.775) && (window.devicePixelRatio == 2)) {
    switch (renderer) {
      default:
        return "iPhone 5, 5C, 5S, SE or 6, 6s, 7 and 8 (display zoom)";
      case "PowerVR SGX 543":
        return "iPhone 5 or 5c";
      case "Apple A7 GPU":
        return "iPhone 5s";
      case "Apple A8 GPU":
        return "iPhone 6 (display zoom)";
      case "Apple A9 GPU":
        return "iPhone SE or 6s (display zoom)";
      case "Apple A10 GPU":
        return "iPhone 7 (display zoom)";
      case "Apple A11 GPU":
        return "iPhone 8 (display zoom)";
    }
    // iPhone 4/4s
  } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 2)) {
    switch (renderer) {
      default:
        return "iPhone 4 or 4s";
      case "PowerVR SGX 535":
        return "iPhone 4";
      case "PowerVR SGX 543":
        return "iPhone 4s";
    }
    // iPhone 1/3G/3GS
  } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 1)) {
    switch (renderer) {
      default:
        return "iPhone 1, 3G or 3GS";
      case "ALP0298C05":
        return "iPhone 3GS";
      case "S5L8900":
        return "iPhone 1, 3G";
    }
  } else {
    return "Not an iPhone";
  }
}